import React from 'react';
import Footer from '../components/footer';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import poops from '../../assets/case1.png';
import lf from '../../assets/lf.png';
import churro from '../../assets/logo-01.png';
import thelot from '../../assets/case4.png';
import Header from '../menu/header2';
import Cyber from '../../assets/cyber.png';
import { Link } from "@reach/router";

const CaseStudies = () => (
  <div>
    <Header/>
    {/* Global style block with hover effects */}
    <style>{`
      .hover-square {
        width: 100%;
        height: 20em;
        border-radius: 10px;
        overflow: hidden;
        box-shadow: 0 4px 8px rgba(0,0,0,0.2);
        transition: transform 0.3s ease, box-shadow 0.3s ease;
        background-color: white;
      }
      .hover-square:hover {
        transform: scale(1.05);
        box-shadow: 0 8px 16px rgba(0,0,0,0.3);
      }
    `}</style>
    <section style={{ paddingTop: '10em', backgroundColor: 'black' }}>
      <Container>
        <Row>
          <Col xs={12} md={4}>
            <Link to="/poopyheads">
              <div className="hover-square" style={{ margin: '0 auto', width: '90%' }}>
                <img
                  src={poops}
                  alt="Sold Out NFT Collection"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </div>
            </Link>
            <p style={{ color: 'white', textAlign: 'center' }}>
              Sold Out Meme NFT Collection
            </p>
          </Col>

          <Col xs={12} md={4}>
            <Link to="/lotusfarm">
              <div className="hover-square" style={{ margin: '0 auto', width: '90%' }}>
                <img
                  src={lf}
                  alt="Ethereum Staking Platform"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </div>
            </Link>
            <p style={{ color: 'white', textAlign: 'center' }}>
              Ethereum Staking Platform
            </p>
          </Col>

          <Col xs={12} md={4}>
            <Link to="/churroswap">
              <div className="hover-square" style={{ margin: '0 auto', width: '90%' }}>
                <img
                  src={churro}
                  alt="Gamified Decentralized Finance Platform"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </div>
            </Link>
            <p style={{ color: 'white', textAlign: 'center' }}>
              Gamified Decentralized Finance Platform
            </p>
          </Col>
        </Row>

        <Row>
          <Col xs={12} md={4}>
            <Link to="/dao">
              <div className="hover-square" style={{ margin: '0 auto', width: '90%' }}>
                <img
                  src={thelot}
                  alt="DAO Social Media - Current Project in progress"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </div>
            </Link>
            <p style={{ color: 'white', textAlign: 'center' }}>
              DAO Social Media - Current Project in progress
            </p>
          </Col> 

          <Col xs={12} md={4}>
            <Link to="/works">
              <div 
                className="hover-square" 
                style={{ 
                  margin: '0 auto', 
                  width: '90%', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center' 
                }}
              >
                <p style={{ textAlign: 'center', margin: 0, fontWeight: 'bold', fontSize: '1.2em', color: 'black' }}>
                  View All Works
                </p>
              </div>
            </Link>
          </Col>

          <Col xs={12} md={4}>
            {/* Empty column to maintain the three-column layout on desktop */}
          </Col>
        </Row>
      </Container>
    </section>

    <Footer />
  </div>
);

export default CaseStudies;
